import script from "./FormBuilder.vue?vue&type=script&setup=true&lang=js"
export * from "./FormBuilder.vue?vue&type=script&setup=true&lang=js"

import "./FormBuilder.vue?vue&type=style&index=0&id=353d266d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-353d266d"]])

export default __exports__